import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonGrid, IonIcon, IonItemDivider, IonItemGroup, IonLabel, IonList, IonLoading, IonPage, IonRow, IonSelect, IonSelectOption } from "@ionic/react";
import { RouteComponentProps } from "react-router";
import { PageContainer, TraineeEntry, TraineeEntryMobil } from "../../components";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../data/redux/hooks";
import { getGroupedAndSortedMasterTrainees, getGroupedAndSortedAdditionalTrainees, GroupedUser } from "../../data/redux/traineeListSlice";
import { filterOutline } from "ionicons/icons";
import FilterModal from "./components/FilterModal";


interface TraineesPreviewCardProps {
    title: string;
    trainees: GroupedUser[];
    group: string;
    setGroup: (group: string) => void;
    sort: string;
    setSort: (sort: string) => void;
}

const TraineesPreviewCard: React.FC<TraineesPreviewCardProps> = ({ title, trainees, group, sort, setGroup, setSort }) => {
    const [filterModalOpen, setFilterModalOpen] = useState<boolean>(false)

    return (
        <>
            <IonCard>
                <IonCardHeader>
                    <div className="reportDesktopHeader">
                        <div>
                            <IonCardTitle className='headline'>{title}</IonCardTitle>
                        </div>
                        <div className="filterTraineesBtn">
                            <IonButton fill="clear" color="dark" onClick={() => setFilterModalOpen(true)}>
                                <IonIcon icon={filterOutline} />
                            </IonButton>
                        </div>
                        <div className="headerSelects">
                            {/* Gruppierung */}
                            <IonSelect
                                interface="popover"
                                placeholder="Gruppierung"
                                aria-label="Gruppierung"
                                onIonChange={(ev) => setGroup(ev.detail.value)}
                                value={group}
                            >
                                <IonSelectOption value="">Keine Gruppierung</IonSelectOption>
                                <IonSelectOption value="job">Berufsgruppe</IonSelectOption>
                                <IonSelectOption value="trainee_year">Lehrjahr</IonSelectOption>
                                <IonSelectOption value="location_id">Standort</IonSelectOption>
                                <IonSelectOption value="department_id">Abteilung</IonSelectOption>
                            </IonSelect>

                            {/* Sortierung */}
                            <IonSelect
                                interface="popover"
                                placeholder="Sortierung"
                                aria-label="Sortierung"
                                value={sort}
                                onIonChange={(ev) => setSort(ev.detail.value)}
                            >
                                <IonSelectOption value="submitted">Einträge unkontrolliert</IonSelectOption>
                                <IonSelectOption value="open">Einträge offen</IonSelectOption>
                                <IonSelectOption value="first_name">Name alphabetisch</IonSelectOption>
                            </IonSelect>
                        </div>
                    </div>

                </IonCardHeader>
                <IonCardContent>
                    {trainees.length === 0 && <p>Ihnen sind derzeit keine Azubis zugeordnet.</p>}
                    <IonList className="ion-hide-md-down">
                        {trainees.map((groupedTrainee) => {
                            return (
                                <IonItemGroup key={groupedTrainee.group_name}>
                                    {groupedTrainee.group_name &&
                                        <IonItemDivider>
                                            <IonLabel>{groupedTrainee.group_name}</IonLabel>
                                        </IonItemDivider>
                                    }
                                    {groupedTrainee.users.map(trainee =>
                                        <TraineeEntry key={trainee.id} trainee={trainee} />
                                    )}
                                </IonItemGroup>
                            )
                        })}
                    </IonList>

                    <IonList className="ion-hide-md-up">
                        {trainees.map((groupedTrainee) => {
                            return (
                                <IonItemGroup key={groupedTrainee.group_name}>
                                    {groupedTrainee.group_name &&
                                        <IonItemDivider>
                                            <IonLabel>{groupedTrainee.group_name}</IonLabel>
                                        </IonItemDivider>
                                    }
                                    {groupedTrainee.users.map(trainee =>
                                        <TraineeEntryMobil key={trainee.id} trainee={trainee} />
                                    )}
                                </IonItemGroup>
                            )
                        })}
                    </IonList>
                </IonCardContent>
            </IonCard>
            <FilterModal
                isOpen={filterModalOpen}
                setIsOpen={setFilterModalOpen}
                group={group}
                setGroup={setGroup}
                sort={sort}
                setSort={setSort}
            />
        </>
    )
}


const TraineesPreview: React.FC<RouteComponentProps> = () => {
    const [group, setGroup] = useState("");
    const [sort, setSort] = useState("first_name");
    const [additionalGroup, setAdditionalGroup] = useState("");
    const [additionalSort, setAdditionalSort] = useState("first_name");
    const { groupedAndSortedMasterTrainees: masterTrainees, groupedAndSortedAdditionalTrainees: additionalTrainees, loading } = useAppSelector((state) => state.traineeList)
    const dispatch = useAppDispatch();


    useEffect(() => {
        dispatch(getGroupedAndSortedMasterTrainees({ group: group, sort: sort }))
    }, [group, sort, dispatch])

    useEffect(() => {
        dispatch(getGroupedAndSortedAdditionalTrainees({ group: additionalGroup, sort: additionalSort }))
    }, [additionalGroup, additionalSort, dispatch])


    return (
        <IonPage>
            <PageContainer name="Meine Azubis" backButton={false}>
                <>
                    <IonGrid>
                        <IonRow>
                            {/* Master Trainees */}
                            <IonCol size="12">
                                <TraineesPreviewCard
                                    title="Meine Azubis"
                                    trainees={masterTrainees}
                                    group={group}
                                    setGroup={setGroup}
                                    sort={sort}
                                    setSort={setSort}
                                />
                            </IonCol>

                            {/* Additional Trainees */}
                            {additionalTrainees.length > 0 && <IonCol size="12">
                                <TraineesPreviewCard
                                    title="Weitere Azubis"
                                    trainees={additionalTrainees}
                                    group={additionalGroup}
                                    setGroup={setAdditionalGroup}
                                    sort={additionalSort}
                                    setSort={setAdditionalSort}
                                />
                            </IonCol>}
                        </IonRow>
                    </IonGrid>
                    <IonLoading isOpen={loading} message={"Lädt..."} />
                </>
            </PageContainer>
        </IonPage>
    )
}

export default TraineesPreview;